import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  modal: {
    position: 'fixed',
    top: 0,
    left: 0,
    zIndex: 999999999999,
    overflow: 'hidden',
    width: '100%',
  },

  wrapper: {
    background: 'white',
    minHeight: '100vh',
    maxHeight: '100vh',
    overflowY: 'auto',
  },

  sectionWrapper: {
    width: '100%',
    padding: '0 32px',
  },
  section: {
    width: '100%',
    paddingBottom: 24,
    marginTop: 24,
    borderBottom: `1px solid ${theme.palette.secondary.light}`,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    flexWrap: 'wrap',
  },
  sectionNoBorder: {
    border: 'none',
  },
  fourColumnGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridTemplateRows: 'auto auto',
    gap: '16px 0px',
    gridTemplateAreas: '". ."". ."',
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
  },
  innerRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
  },
  icon: {
    color: theme.palette.secondary.dark,
  },
  iconLabel: {
    marginLeft: 10,
  },
  backButtonWrapper: {
    width: '100%',
    marginTop: 32,
    padding: '0 16px',
    marginBottom: 36,
  },
  backButton: {
    width: '100%',
  },
}))

export default useStyles
